import { gatewayFetch, type GatewayRequest } from "src/managers/GatewayProxy";
import { ESInterfaceBase } from "./ESInterfaceBase.ts";

export type { UTMGridData, UTMGridItem } from "./ESInterfaceBase.ts";

/**
 * Interface to Elastic Search, through viamap-gatewayproxy. Logged-out users can only search and count the
 * property search index; everything else requires a login.
 */

export class ESInterface extends ESInterfaceBase {

   constructor(index: string) {
      super(index);
   }

   protected async executeQuery(urlCommand: string, query: any): Promise<any> {
      const response = await gatewayFetch("es", urlCommand, { body: query });
      if (response.status != 200) {
         throw new Error(response.statusText);
      }
      return response.json();
   }

   async indexExists(indexName: string): Promise<boolean> {
      try {
         const response = await gatewayFetch("es", indexName, { method: "HEAD" });
         return response.status === 200;
      } catch {
         return false;
      }
   }

   async runCommand(method: string, urlCommand: string, body: any, noJSON = false): Promise<any> {
      const request: GatewayRequest = { method: method as GatewayRequest["method"] };
      if (noJSON) {
         request.rawBody = body;
      } else if (body === undefined || body === null) {
         if (method === "PUT" || method === "POST") {
            request.rawBody = "{}";
         }
      } else {
         try {
            request.rawBody = JSON.stringify(body);
         } catch (err: any) {
            throw new Error(`Elasticsearch: failed to serialize request body - ${err?.message || err}`);
         }
      }

      const response = await gatewayFetch("es", urlCommand, request);
      let result = await response.json();
      if (result.error) {
         throw new Error(result.error.reason ?? result.error);
      }
      return result;
   }
}
